import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
export async function getPhysiciansListAPI(data) {
    return axiosClientStilo.get(`/api/v1/admin/physicians/list?${getQueryString(data)}&userType=admin`);
}

export async function fetchPhysiciansDetailsAPI(physiciansId) {
    return  axiosClientStilo.get(`/api/v1/admin/physicians/${physiciansId}`);
}

export async function addPhysiciansAPI(data) {
    return  axiosClientStilo.post(`/api/v1/admin/physicians/add`, data);
}

export async function updatePhysiciansAPI(data,physiciansId) {
    return  axiosClientStilo.put(`/api/v1/admin/physicians/${physiciansId}`, data);
}

export async function deletePhysiciansAPI(physiciansId) {
    return  axiosClientStilo.delete(`/api/v1/admin/physicians/${physiciansId}`);
}
